document.addEventListener('DOMContentLoaded', function () {
  var btn = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (btn && menu) {
    btn.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden');
      if (open) {
        menu.removeAttribute('hidden');
      } else {
        menu.setAttribute('hidden', '');
      }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var initializeGallery = function (gallery) {
    if (gallery.hasAttribute('data-gallery-ready')) return;
    var viewport = gallery.querySelector('[data-gallery-viewport]');
    var slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    var dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    var previous = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (!viewport || slides.length < 2) return;
    gallery.setAttribute('data-gallery-ready', '');

    var activeIndex = 0;
    var showSlide = function (index) {
      activeIndex = (index + slides.length) % slides.length;
      viewport.scrollTo({ left: slides[activeIndex].offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
    };
    var updateDots = function (index) {
      activeIndex = index;
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    if (previous) previous.addEventListener('click', function () { showSlide(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { showSlide(activeIndex + 1); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { showSlide(index); });
    });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(activeIndex + 1);
      }
    });

    var dragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    viewport.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button, video, model-viewer')) return;
      dragging = true;
      startX = event.clientX;
      startScrollLeft = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      viewport.scrollLeft = startScrollLeft - (event.clientX - startX);
    });
    var finishDrag = function (event) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      var slideWidth = slides[0].getBoundingClientRect().width;
      if (slideWidth > 0) showSlide(Math.round(viewport.scrollLeft / slideWidth));
    };
    viewport.addEventListener('pointerup', finishDrag);
    viewport.addEventListener('pointercancel', finishDrag);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          updateDots(slides.indexOf(entry.target));
        }
      });
    }, { root: viewport, threshold: 0.6 });
    slides.forEach(function (slide) { observer.observe(slide); });

    gallery.showMedia = function (mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
          showSlide(i);
          return;
        }
      }
    };
  };

  document.querySelectorAll('[data-product-gallery]').forEach(initializeGallery);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product-gallery]').forEach(initializeGallery);
  });

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var variantSelect = section.querySelector('select[name="id"]');
    var currentPrice = section.querySelector('[data-current-price]');
    var comparePrice = section.querySelector('[data-compare-price]');
    var saleBadge = section.querySelector('[data-sale-badge]');
    if (!variantSelect || !currentPrice || !comparePrice || !saleBadge) return;

    variantSelect.addEventListener('change', function () {
      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (!selectedOption) return;
      var originalPrice = selectedOption.getAttribute('data-compare-price') || '';
      currentPrice.textContent = selectedOption.getAttribute('data-price') || '';
      comparePrice.textContent = originalPrice;
      comparePrice.classList.toggle('is-hidden', !originalPrice);
      saleBadge.classList.toggle('is-hidden', !originalPrice);

      var gallery = section.querySelector('[data-product-gallery]');
      var mediaId = selectedOption.getAttribute('data-media-id');
      if (gallery && gallery.showMedia) gallery.showMedia(mediaId);
    });
  });
});
